import { useDispatch, useSelector } from "react-redux";

import { QuotaContactAdminModal } from "app/pages/sales-intelligence/modules/quota/components/QuotaContactAdminModal/QuotaContactAdminModal";
import {
    selectIsQuotaContactAdminModalOpen,
    setQuotaContactAdminModalOpen,
} from "app/pages/sales-intelligence/modules/quota/store";

export const QuotaContactAdminModalContainer = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(selectIsQuotaContactAdminModalOpen);

    return (
        <QuotaContactAdminModal
            isOpen={isOpen}
            onClose={() => dispatch(setQuotaContactAdminModalOpen(false))}
        />
    );
};
